import { render, staticRenderFns } from "./ZcfgListNew.vue?vue&type=template&id=4147cde3&scoped=true"
import script from "./ZcfgListNew.vue?vue&type=script&lang=js"
export * from "./ZcfgListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4147cde3",
  null
  
)

export default component.exports